export const AuthActionType = {
  SIGN_IN_API: 'AUTH.SIGN_IN_API',
  SIGN_IN_API_SUCCESS: 'AUTH.SIGN_IN_API_SUCCESS',
  SIGN_IN_API_FAILURE: 'AUTH.SIGN_IN_API_FAILURE',
  CHANGE_SIGN_IN_INPUT_VALUE: 'AUTH.CHANGE_SIGN_IN_INPUT_VALUE',
  SET_PROPERTY_VALUE: 'AUTH.SET_PROPERTY_VALUE',
  SIGN_OUT_API: 'AUTH.SIGN_OUT_API',
}